import "@ingka/text/dist/style.css"
import {FC, useEffect, useState} from "react"
import Localization from "../Utils/TranslationHelper"
import {findInURL} from "./../Utils/LocaleHelper"

import {IShoppingItem, IShoppingProduct} from "@inter-ikea-kompis/types"

import {KompisSummaryPage} from "@inter-ikea-kompis/react-components"
import {SkapaTheme} from "@inter-ikea-kompis/themes"
import DexfSettings from "../Utils/DexfSettings"
import ProductConfiguration from "../Utils/ProductHelper"
import VPCConfiguration from "./../Utils/VpcHelper"

const ItemList: FC = () => {
  const [localizedInformation, setLocalizedInformation] = useState<any>()

  const [shoppingProducts, setShoppingProducts] = useState<IShoppingProduct[]>(
    []
  )

  const [mainDesignImage, setMainDesignImage] = useState("")

  useEffect(() => {
    const productService = new ProductConfiguration()
    const localisation = new Localization()
    const dexfService = new DexfSettings()
    const configuration = new VPCConfiguration()

    dexfService.getSettings().then((dexfSettings) => {
      const vpcCode = findInURL("vpc-code")

      if (vpcCode !== null) {
        configuration.getConfiguration(vpcCode, dexfSettings).then((data) => {
          if (data) {
            getShoppingList(data.itemList as IShoppingItem[])
            if (data.imageUrl) {
              setMainDesignImage(data.imageUrl[0].url)
            }
          }
        })
      }

      const getShoppingList = (shoppingList: IShoppingItem[]) => {
        productService
          .getShoppingProducts(shoppingList, dexfSettings)
          .then((newShoppingProducts) => {
            if (newShoppingProducts) {
              setShoppingProducts(newShoppingProducts)
            }
          })
      }

      localisation.getLocalization().then((localizationData) => {
        const combinedData = {
          localization: dexfSettings.localisation || {},
          priceSettings: dexfSettings.localisation || {},
          urls: dexfSettings.kompis.urls || {},
          translations: localizationData.kompis || {},
          endpoints: dexfSettings.kompis.endpoints || {},
        }
        setLocalizedInformation(combinedData)
      })
    })
  }, [])

  return (
    <>
      {localizedInformation && shoppingProducts.length > 0 && (
        <KompisSummaryPage
          shoppingProducts={shoppingProducts}
          localizedInformation={localizedInformation}
          theme={SkapaTheme}
          locale={"en-SE"}
          stores={[]}
          enableMargins={false}
          screenshotUrl={mainDesignImage ? mainDesignImage : ""}
        />
      )}
    </>
  )
}

export default ItemList
